import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-231" data-mp="3fznvbprkvj3h">
      <div className="mx-auto max-w-4xl" data-id="element-232" data-mp="3fxuni758astw">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-brand-600" data-id="element-233" data-mp="3b0uilzk47w4d">
          ⭐ Cosa dicono gli altri medici
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-234" data-mp="370akasnt2mgn">
          +2.000 professionisti usano già questa metodologia
        </h2>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-235" data-mp="2x2w3ut1vtxoc">
          {testimonials.map(t => <figure key={t.name} className="flex h-full flex-col rounded-3xl border border-brand-100 bg-cream p-5 sm:p-6" data-id="element-236" data-mp="2s3t9q3nfxbv5">
              <div className="flex gap-0.5" aria-label="Valutazione 5 su 5" data-id="element-237" data-mp="qbeqn195u1d5">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-238" data-mp="h814jfcje0g9" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[14px] font-medium leading-relaxed text-ink/85 sm:text-[15px]" data-id="element-239" data-mp="c6vdrn2fsn9d">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-240" data-mp="zwxzllfrcwzj">
                <img src={t.image} alt={`Foto di ${t.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} loading="lazy" data-id="element-241" data-mp="14uhfsqw0nju4" />
                <span className="min-w-0" data-id="element-242" data-mp="1iv1yzo5ufho5">
                  <span className="block text-[14px] font-bold leading-tight text-ink" data-id="element-243" data-mp="1itzafmvztrbe">
                    {t.name}
                  </span>
                  <span className="block text-[12px] font-medium leading-tight text-inksoft" data-id="element-244" data-mp="1xhqzntbu00w4">
                    {t.role}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-10" data-id="element-245" data-mp="1ofrdynpvg8mu">
          <CtaButton label="Unisciti ai +2.000 medici" note="Accesso immediato · Pagamento unico di €19" data-id="element-246" data-mp="1oj5ju5xquzz1" />
        </div>
      </div>
    </section>;
}